// This identifies the connected request contract, not live provider health.
export const CURRENT_PROPERTY_REPORT_SOURCE = { id: 'lightstone', label: 'Lightstone' };

export function propertyReportSourceError(provider) {
    if (provider === undefined || provider === CURRENT_PROPERTY_REPORT_SOURCE.id) return null;
    return {
        ok: false,
        code: 'PROPERTY_REPORT_SOURCE_UNAVAILABLE',
        message: provider === 'cma-info'
            ? 'CMA Info is not available for new reports here yet. Reuse a saved report or upload a PDF instead.'
            : 'The selected report source is not available. Reuse a saved report or upload a PDF instead.',
    };
}
